import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { makeReducerFromScaffold, bindEntityScaffold } from '@classpass/saga-tools';
import { combineReducers } from 'redux';
import * as entities from './entities';
export default combineReducers(Object.keys(entities).reduce(function (memo, key) {
  return _objectSpread({}, memo, _defineProperty({}, key, makeReducerFromScaffold(entities[key])));
}, {}));

var bindForReducer = function bindForReducer(name) {
  return bindEntityScaffold(entities[name], function (state) {
    return state.entities[name];
  });
};

export var achievementsPastReservations = bindForReducer('achievementsPastReservations');
export var achievementsPastReservationsCount = bindForReducer('achievementsPastReservationsCount');
export var activityList = bindForReducer('activityList');
export var cancelReservation = bindForReducer('cancelReservation');
export var createReservation = bindForReducer('createReservation');
export var charges = bindForReducer('charges');
export var classBundlesByMsa = bindForReducer('classBundlesByMsa');
export var classInfoByVenueAlias = bindForReducer('classInfoByVenueAlias');
export var classesByVenue = bindForReducer('classesByVenue');
export var cms = bindForReducer('cms');
export var cmsLegalContent = bindForReducer('cmsLegalContent');
export var cmsWebContent = bindForReducer('cmsWebContent');
export var cmsWebData = bindForReducer('cmsWebData');
export var contentTags = bindForReducer('contentTags');
export var contentTagsV2 = bindForReducer('contentTagsV2');
export var getCountries = bindForReducer('getCountries');
export var createGift = bindForReducer('createGift');
export var createLiveSubscription = bindForReducer('createLiveSubscription');
export var createSubscription = bindForReducer('createSubscription');
export var createSubscriptionCache = bindForReducer('createSubscriptionCache');
export var createVideoReservation = bindForReducer('createVideoReservation');
export var creditBounds = bindForReducer('creditBounds');
export var defaultPromotion = bindForReducer('defaultPromotion');
export var emailOptIn = bindForReducer('emailOptIn');
export var jobs = bindForReducer('jobs');
export var jobById = bindForReducer('jobById');
export var postApplication = bindForReducer('postApplication');
export var dashFeatureById = bindForReducer('dashFeatureById');
export var featureById = bindForReducer('featureById');
export var filtersByHash = bindForReducer('filtersByHash');
export var filtersByQuery = bindForReducer('filtersByQuery');
export var fitnessDeviceTracking = bindForReducer('fitnessDeviceTracking');
export var fitnessTrendsMember = bindForReducer('fitnessTrendsMember');
export var friendbuy = bindForReducer('friendbuy');
export var geocode = bindForReducer('geocode');
export var getAddressRequirements = bindForReducer('getAddressRequirements');
export var glsLocation = bindForReducer('glsLocation');
export var holdPlanByMsa = bindForReducer('holdPlanByMsa');
export var keywordAutocomplete = bindForReducer('keywordAutocomplete');
export var leaderboardJoinClass = bindForReducer('leaderboardJoinClass');
export var leaderboardLeaveClass = bindForReducer('leaderboardLeaveClass');
export var leaderboardUpdateHeartrate = bindForReducer('leaderboardUpdateHeartrate');
export var leaderboardUpdateClientStatus = bindForReducer('leaderboardUpdateClientStatus');
export var liveVideos = bindForReducer('liveVideos');
export var liveVideoDetail = bindForReducer('liveVideoDetail');
export var livePlans = bindForReducer('livePlans');
export var livePlansByMsa = bindForReducer('livePlansByMsa');
export var livePlanById = bindForReducer('livePlanById');
export var liveSubscription = bindForReducer('liveSubscription');
export var locationAutocomplete = bindForReducer('locationAutocomplete');
export var locationsByMsa = bindForReducer('locationsByMsa');
export var locationSearch = bindForReducer('locationSearch');
export var modals = bindForReducer('modals');
export var movementByAlias = bindForReducer('movementByAlias');
export var msaById = bindForReducer('msaById');
export var msaCreditStatById = bindForReducer('msaCreditStatById');
export var msaOfferById = bindForReducer('msaOfferById');
export var msas = bindForReducer('msas');
export var nearbyPopularVenues = bindForReducer('nearbyPopularVenues');
export var pageContentByKey = bindForReducer('pageContentByKey');
export var pageIndexByKey = bindForReducer('pageIndexByKey');
export var paymentTypes = bindForReducer('paymentTypes');
export var planById = bindForReducer('planById');
export var plansByMsa = bindForReducer('plansByMsa');
export var isUserVerified = bindForReducer('isUserVerified');
export var onDemandVideos = bindForReducer('onDemandVideos');
export var promotionByAlias = bindForReducer('promotionByAlias');
export var promotionsByMsa = bindForReducer('promotionsByMsa');
export var purchaseClassBundle = bindForReducer('purchaseClassBundle');
export var redeemSubscriptionCode = bindForReducer('redeemSubscriptionCode');
export var relatedFiltersByHash = bindForReducer('relatedFiltersByHash');
export var reviewsForClass = bindForReducer('reviewsForClass');
export var reviewsForVenue = bindForReducer('reviewsForVenue');
export var saveOffer = bindForReducer('saveOffer');
export var searchLayoutByName = bindForReducer('searchLayoutByName');
export var searchLocationAutocomplete = bindForReducer('searchLocationAutocomplete');
export var searchLocationDetails = bindForReducer('searchLocationDetails');
export var searchSchedules = bindForReducer('searchSchedules');
export var searchMovements = bindForReducer('searchMovements');
export var scheduleById = bindForReducer('scheduleById');
export var scheduleForClass = bindForReducer('scheduleForClass');
export var scheduleForVenue = bindForReducer('scheduleForVenue');
export var similarVenues = bindForReducer('similarVenues');
export var studioBookmarks = bindForReducer('studioBookmarks');
export var tagList = bindForReducer('tagList');
export var taggedContent = bindForReducer('taggedContent');
export var taxRate = bindForReducer('taxRate');
export var userActionCampaign = bindForReducer('userActionCampaign');
export var userActionCampaignEvent = bindForReducer('userActionCampaignEvent');
export var userAnnouncements = bindForReducer('userAnnouncements');
export var userCancelMembership = bindForReducer('userCancelMembership');
export var userBillingDetails = bindForReducer('userBillingDetails');
export var userCreditBalance = bindForReducer('userCreditBalance');
export var userCreditBalanceBreakdown = bindForReducer('userCreditBalanceBreakdown');
export var userInactivePermissions = bindForReducer('userInactivePermissions');
export var userPastReservations = bindForReducer('userPastReservations');
export var userPastReservationsCount = bindForReducer('userPastReservationsCount');
export var userPermissions = bindForReducer('userPermissions');
export var userProfile = bindForReducer('userProfile');
export var userAccountSummary = bindForReducer('userAccountSummary');
export var userSignUpEmail = bindForReducer('userSignUpEmail');
export var userSignUpFacebook = bindForReducer('userSignUpFacebook');
export var userSubscription = bindForReducer('userSubscription');
export var userUpcomingReservations = bindForReducer('userUpcomingReservations');
export var userVideoReservations = bindForReducer('userVideoReservations');
export var venueByIdV2 = bindForReducer('venueByIdV2');
export var venueList = bindForReducer('venueList');
export var venueListV2 = bindForReducer('venueListV2');
export var venueSiblings = bindForReducer('venueSiblings');
export var verifyGift = bindForReducer('verifyGift');
export var videoBookmarks = bindForReducer('videoBookmarks');
export var videoCollection = bindForReducer('videoCollection');
export var videoStacks = bindForReducer('videoStacks');
export var videoCompletedViews = bindForReducer('videoCompletedViews');
export var videoDetails = bindForReducer('videoDetails');
export var videoTracking = bindForReducer('videoTracking');
export var videoViewRatings = bindForReducer('videoViewRatings');
export var videos = bindForReducer('videos');
export var videosFilters = bindForReducer('videosFilters');
export var waitlistRequest = bindForReducer('waitlistRequest');
export var zipCodeToLatLng = bindForReducer('zipCodeToLatLng');